import React, { useEffect, useState } from "react";
import UtilsUrl from "../../../utils/UtilsUrl";

const DeliveryNoteTable = ({ date, data, matriculeTransporteur }) => {
    const [image, setImage] = useState(null);
    const [contentTable, setContentTable] = useState([]);
    const [cartonTotal, setCartonTotal] = useState(0);

    useEffect(() => {
        if (data?.success) {
            let tablein = [...data.success];
            tablein.sort((a, b) => new Date(a.creation_date) - new Date(b.creation_date));
            setContentTable(tablein);

            // Calculate the total cartons
            let total = 0;
            tablein.forEach(item => {
                if (item.unite !== null && item.unite !== 0) {
                    total += item.quantity / item.unite;
                }
            });
            setCartonTotal(total.toFixed(2));
        }
    }, [data]);

    function formatDate(date) {
        const [year, month, day] = date.split('-');
        return `${day.padStart(2, '0')}.${month.padStart(2, '0')}.${year}`;
    }

    const handlePrint = () => {
        const divToPrint = document.getElementById("bon-sortie");
        if (!divToPrint) {
            console.error("Element with id 'bon-sortie' not found.");
            return;
        }

        const newWin = window.open("", "PrintWindow", "width=800,height=600");

        newWin.document.write(`
        <html>
            <head>
                <title>Bon sortie</title>
            </head>
            <body>
                ${divToPrint.outerHTML}
            </body>
        </html>
    `);

        setTimeout(() => {
            newWin.print();
            newWin.close();
        }, 1000);
    };

    function calculateCarton(item) {
        if (item.unite !== null && item.unite !== 0) {
            return (item.quantity / item.unite).toFixed(2);
        }
        return "0.00";
    }

    return (
        <div style={{
            padding: "5px", fontFamily: "Arial, sans-serif", fontSize: "10px",
        }}>
            <div id="bon-sortie">
                <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "5px", fontSize: "10px" }}>
                    <div style={{ maxWidth: '30%' }}>
                        <h6 style={{ margin: 0 }}>{data?.societe?.title}</h6>
                        <p style={{ margin: 0 }}>Adresse :{data?.societe?.adresse}</p>
                        <p style={{ margin: 0 }}>Numéro d'enregistrement :{data?.societe?.matricule} / {data?.societe?.codeCategorie} / {data?.societe?.codeTVA}</p>
                    </div>
                    <div>
                        <p style={{ margin: 0 }}>CHAUFFEUR: {data?.transporteur?.firstName} {data?.transporteur?.lastName}</p>
                        <p style={{ margin: 0 }}>N° C.I.N :{data?.transporteur?.cin}</p>
                        <p style={{ margin: 0 }}>N° Telephone :{data?.transporteur?.phoneNumber}</p>
                        {matriculeTransporteur
                            ? <p style={{ margin: 0 }}>IMMATRICULATION : {matriculeTransporteur}</p>
                            : data?.transporteur?.truck && <p style={{ margin: 0 }}>IMMATRICULATION : {data.transporteur.truck}</p>
                        } </div>
                    <div style={{ maxWidth: '30%' }}>
                        <p style={{ margin: 0 }}>
                            DESTINATION: {data?.zone?.description}
                        </p>
                    </div>
                </div>

                <h6 style={{ textAlign: "center", marginBottom: "5px" }}>Bon de Sortie</h6>

                <table
                    style={{
                        width: "100%",
                        borderCollapse: "collapse",
                        marginTop: "5px",
                        textAlign: "center",
                        fontSize: "10px"
                    }}
                >
                    <thead>
                        <tr>
                            <th style={{ border: "1px solid black", padding: "2px", backgroundColor: "#f2f2f2" }}>Désignation</th>
                            <th style={{ border: "1px solid black", padding: "2px", backgroundColor: "#f2f2f2" }}>Quantité</th>
                            <th style={{ border: "1px solid black", padding: "2px", backgroundColor: "#f2f2f2" }}>Colis</th>
                        </tr>
                    </thead>
                    <tbody>
                        {Array.isArray(contentTable) &&
                            contentTable.map((item, index) => (
                                <tr key={index}>
                                    <td style={{ border: "1px solid black", padding: "0", textAlign: "left", paddingLeft: "2px" }}>
                                        {item.name}
                                    </td>
                                    <td style={{ border: "1px solid black", padding: "0" }}>
                                        {item.quantity}
                                    </td>
                                    <td style={{ border: "1px solid black", padding: "0" }}>
                                        {calculateCarton(item)}
                                    </td>
                                </tr>
                            ))}
                    </tbody>
                </table>
                <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "5px" }}>
                    <h7 style={{ margin: 0, marginTop: "2px" }}>Total des colis: {cartonTotal}</h7>
                </div>
                <div style={{ marginTop: "5px", display: "flex", justifyContent: "flex-end", textAlign: "right" }}>
                    <div>
                        <p style={{ marginBottom: "5px" }}>DATE : {formatDate(date)}</p>
                        <p>Signature: __________________</p>
                    </div>
                </div>
            </div>
            <div className="card-footer">
                <button className="btn btn-dark float-right" onClick={handlePrint}>
                    Imprimer
                </button>
            </div>
        </div>
    );
};

export default DeliveryNoteTable;